import { useEffect, useMemo, useState } from 'react'
import { useSearchLogsBatchQuery } from 'hooks/api'

import { WIDGET_KIND } from 'lib/dashboards-constants'
import { getLogsKey } from 'lib/dashboards-helpers'

const getPayloads = (widgets, start, end) => {
  if (!widgets) return []

  const logsWidgets = widgets?.filter(widget => widget.kind === WIDGET_KIND.LOGS)

  const payloads = logsWidgets.map(widget => {
    const payload = {
      targets: widget.definition.targets,
      service: widget.definition.service,
      query: widget.definition.query || '',
      start,
      end,
      limit: 30,
      metrics: false,
      ...(widget.definition.service === 'lambda' && { groupBy: 'executions' })
    }

    return { id: getLogsKey(widget), payload }
  })

  return payloads
}

const useLogsFetcher = ({ widgets, start, end, refreshInterval }) => {
  const [invocations, setInvocations] = useState([])

  const payloads = useMemo(() => getPayloads(widgets, start, end), [widgets, start, end])
  const data = useSearchLogsBatchQuery(payloads, refreshInterval)
  const loading = useMemo(() => data.some(item => item.isLoading), [data])
  const fetching = useMemo(() => data.some(item => item.isFetching), [data])

  const refetch = (e) => {
    e?.stopPropagation()
    data.map(item => item?.refetch())
  }

  const formatData = () => {
    if (loading || fetching) return

    const mappedInvocations = data?.reduce((acc, item) => {
      acc[item?.data?.id] = item.data
      return acc
    }, {})

    setInvocations(mappedInvocations)
  }

  useEffect(formatData, [payloads, loading, fetching])

  return { data: invocations, loading, fetching, refetch }
}

export default useLogsFetcher
